export default __webpack_public_path__ + "static/media/38_desktop.118b3ea4.jpg";